import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { NavController, NavParams } from 'ionic-angular';
import { Subscription } from 'rxjs';
import { PaymentProvider } from '../../providers/payment';
import * as fromAuth from '../../ngrx/reducers/auth.reducer';
import { AnalyticsData, _ACTIONS } from '../../providers/analytics';
import { AnimationService } from 'css-animator';
import { has } from 'lodash';

const componentName = 'DetailShoppingCartHelperComponent';

@Component({
  selector: 'detail-shopping-cart-helper',
  templateUrl: 'detail-shopping-cart-helper.html'
})
export class DetailShoppingCartHelperComponent implements OnChanges, OnDestroy {

  @Input() isOpen = false;
  @Input() eventId: string = '--';
  @Input() uidTrack: string;
  @Input() openForm: string;
  @Input() viewCartFrom: any;
  @Input() config: any;
  @Output() onChangeFlag = new EventEmitter();

  private userSubscribe: Subscription;
  public shoppingCart$: Observable<any>;

  constructor(
    public navParams: NavParams,
    public animationService: AnimationService,
    private store: Store<{}>,
    private navCtrl: NavController,
    private paymentData: PaymentProvider,
    private analytics: AnalyticsData,
  ) {
  }

  ngOnInit() {
    this.userSubscribe = this.store.select(fromAuth.getUser)
      .subscribe(user => {
        if (user) {
          this.shoppingCart$ = this.paymentData.getUserShoppingCart(user.info.id);
        }
      });
  }

  ngOnChanges(simpleChanges: SimpleChanges) {
    if (has(simpleChanges, "isOpen")) {
      if (simpleChanges.isOpen.currentValue) {
        this.isOpen = simpleChanges.isOpen.currentValue;
      }
    }
  }

  public shoppinCart(openForm) {
    switch (openForm) {
      case 'catalog':
        this.navCtrl.push('ShoppingCart', { eventId: this.eventId });
        this.onChangeFlag.emit(false);
        // TrackingAction - viewCart
        this.analytics.savePageTrackOnFirestore(
          componentName,
          _ACTIONS.viewCartCatalog,
          this.uidTrack,
          { params: this.navParams.data, viewCartFrom: this.viewCartFrom }
        );
        break;

      case 'ticket':
        this.navCtrl.push('ShoppingTicketCartPage', { eventId: this.eventId });
        this.onChangeFlag.emit(false);
        // TrackingAction - viewCart
        this.analytics.savePageTrackOnFirestore(
          componentName,
          _ACTIONS.viewCartTicket,
          this.uidTrack,
          { params: this.navParams.data, viewCartFrom: this.viewCartFrom }
        );
        break;
    }
  }

  public closeHelper() {
    this.onChangeFlag.emit(false);
  }

  public ngOnDestroy() {
    if (this.userSubscribe) { this.userSubscribe.unsubscribe(); }
  }
}



// WEBPACK FOOTER //
// ./src/components/detail-shopping-cart-helper/detail-shopping-cart-helper.ts